import { Component, ViewEncapsulation } from '@angular/core';

import { TdIssuesService } from './../td-issues/td-issues.service';

import { RecordService } from './record.service';
import { Record } from '../record-item/record-item.model';

declare var jQuery:any;
declare var Fr:any;
declare var Materialize:any;
declare var window:any;
declare var navigator:any;

@Component({
  selector: 'record',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
  providers: [RecordService],
  encapsulation: ViewEncapsulation.None
})
export class RecordComponent {
  idPost:any;
  records:Record[];
  recordRemove:Record;
  mediaOptions:any;
  media:any;
  stream:any;
  isDontRecord:boolean;
  isDontStop:boolean;
  isDontBrowserSupportHttps:boolean;
  isDontBrowserSupportHttpsMessage:string;
  isDontInputDevice:boolean;
  isDontInputDeviceMessage:string;

  // Native elements.
  recorder:any;

  constructor(private recordService:RecordService, private issuesService:TdIssuesService) {
    this.idPost = jQuery('#td-record-box').attr('data-post-id');
    this.isDontRecord = false;
    this.isDontStop = true;
    this.recorder = Fr.voice;
    this.isDontBrowserSupportHttps = false;
    this.isDontBrowserSupportHttpsMessage = '';
    this.isDontInputDevice = false;
    this.isDontInputDeviceMessage = '';

    this.mediaOptions = {
      audio: {
        tag: 'audio',
        type: 'audio/mp3',
        ext: '.mp3',
        gUM: {
          audio: true
        }
      }
    };

    this.records = [];
    this.recordService
      .getRecords(this.idPost)
      .subscribe(data => {
          this.records = data.records;
        },
        err => {
          Materialize.toast(`<p>${err.message}</p>`, 10000);
          console.error(err)
        },
        () => console.log('done')
      );
  }

  private onOut(args:any) {
    this.recordService
      .postRecords(this.records, this.idPost)
      .subscribe((data:any) => {
          if (data) {
            Materialize.toast(`<p>The record was changed :)</p>`, 3000);
          } else {
            Materialize.toast(`<p>The record wasn't changed :(</p>`, 3000);
          }
        },
        err => {
          Materialize.toast(`<p>${err}</p>`, 10000);
        },
        () => console.log('done')
      );
  }

  /**
   * When click on record button then launch user media.
   */
  record():void {
    let that = this;

    if (location.protocol != 'https:') {
      Materialize.toast(`<p>Warning: some web browsers only allow you to record voice if they are on HTTPS connection.</p>`, 10000);
    }

    if (!this.isDontBrowserSupportHttps) {
      this.recorder.record('', function (stream) {
        that.isDontInputDevice = false;
        if (stream) {
          that.makeWaveform();
        } else {
          that.isDontInputDevice = true;
          that.isDontInputDeviceMessage = 'No live audio input';
          Materialize.toast(`<p>Error: No live audio input.</p>`, 10000);
          that.isDontStop = true;
        }
      });
      this.isDontStop = false;
    }
  }

  makeWaveform() {
    var analyser = Fr.voice.recorder.analyser;

    var bufferLength = analyser.frequencyBinCount;
    var dataArray = new Uint8Array(bufferLength);

    /**
     * The Waveform canvas
     */
    var WIDTH = 500,
      HEIGHT = 200;

    let $canvaDom = jQuery("#wp-record-level");
    $canvaDom.show().siblings().hide();

    var canvasCtx = $canvaDom[0].getContext("2d");
    canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);

    function draw() {
      var drawVisual = requestAnimationFrame(draw);

      analyser.getByteTimeDomainData(dataArray);

      canvasCtx.fillStyle = 'rgb(200, 200, 200)';
      canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = 'rgb(0, 0, 0)';

      canvasCtx.beginPath();

      var sliceWidth = WIDTH * 1.0 / bufferLength;
      var x = 0;
      for (var i = 0; i < bufferLength; i++) {
        var v = dataArray[i] / 128.0;
        var y = v * HEIGHT / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }
      canvasCtx.lineTo(WIDTH, HEIGHT / 2);
      canvasCtx.stroke();
    };
    draw();
  }

  pause() {
    this.recorder.pause();
  }

  resume() {
    this.recorder.resume();
  }

  /**
   * Stop record.
   */
  stop():void {
    let that = this;

    this.recorder.export(function (url) {
      that.upload(url);
    }, "blob");

    this.recorder.stop();
    this.isDontStop = true;
  }

  /**
   * Upload record.
   */
  upload(url):void {
    let token = Math.random().toString(36).substr(10);

    var fd:FormData = new FormData();
    fd.append('files', url, token + this.mediaOptions.audio.ext);
    fd.append('id', this.idPost);

    this.recordService
      .postRecordUpload(fd, this.idPost)
      .subscribe((data:any) => {
          if (data.record) {
            this.records.push(data.record);
            jQuery('.td-collection').trigger("click");
          } else {
            Materialize.toast(`<p>The record don't upload :(</p>`, 10000);
          }
        },
        err => {
          Materialize.toast(`<p>${err}</p>`, 10000);
        },
        () => console.log('done')
      );
  }

  /**
   * Remove sure modal.
   *
   * @param recordId
   */
  removeSure(record:Record):void {
    this.records.forEach((value:Record) => {
      if (value.id == record.id) {
        this.recordRemove = new Record(value.post_id, value.id, value.attach_id, value.url, value.name);
        jQuery('#modal-remove-sure').modal('open');
      }
    });
  }

  /**
   * Remove record.
   *
   * @param record
   */
  remove(record:Record):void {
    this.recordService
      .getRemoveRecord(this.idPost, record.id)
      .subscribe(data => {
          if (data.result) {
            let records = this.records;
            this.records = [];
            records.forEach((value:any) => {
              if (value.id != record.id) {
                this.records.push(value);
              }
            });
            jQuery('#modal-remove-sure').modal('close');
            Materialize.toast(`<p>Record removed :)</p>`, 3000);
            jQuery('#content_ifr').contents().find("p:contains(" + record.id + ")").remove();
          } else {
            Materialize.toast(`<p>Record don't removed :(</p>`, 10000);
          }
        },
        err => {
          Materialize.toast(`<p>${err.message}</p>`, 10000);
          console.error(err)
        },
        () => console.log('done')
      );
  }

  closeModal() {
    jQuery('#modal-remove-sure').modal('close');
  }

  closeSideNav() {
    jQuery('.button-collapse').sideNav('hide');
  }

  redirectToHttps() {
    if (location.protocol != 'https:') {
      location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    }
  }

  ngOnInit() {
    // Modal Initialization.
    jQuery('.modal').modal({
      dismissible: true
    });

    // SideNav Initialization.
    jQuery('.button-collapse').sideNav({
        menuWidth: 300,
        edge: 'right',
        //closeOnClick: true,
        draggable: true
      }
    );

    setTimeout(function () {
      jQuery('#content_ifr').contents().find("strong:contains('wp-record')").each(function () {
        jQuery(this).removeAttr('id');
      });

      jQuery(document).on('click', 'body, p, strong', function (e:any) {
        jQuery('.td-collection-item').removeClass('td-check-record');
        e.stopPropagation();
      });

      jQuery('#content_ifr').contents().find("p, p:contains('wp-record'), strong, strong:contains('wp-record')").bind('click', function () {
        jQuery('.td-collection-item').removeClass('td-check-record');
        let shortcode = jQuery(this).html();
        if (shortcode.indexOf('id') >= 0) {
          shortcode = shortcode.replace(/\[/g, ' ');
          shortcode = shortcode.replace(/\]/g, ' ');
          shortcode = shortcode.split(' ');
          shortcode.forEach((value:any) => {
            if (value.indexOf('id') >= 0) {
              let id = value.split('="')[1];
              if (id) {
                id = id.substring(0, id.length - 1);
                let $itemRecord = jQuery('#record-' + id);

                if ($itemRecord.length > 0) {
                  $itemRecord.addClass('td-check-record');

                  let $modalShortcode = jQuery('#modal-shortcode');
                  $modalShortcode.find('.sht-title').html($itemRecord.find('.title').html());
                  $modalShortcode.find('audio').attr('src', $itemRecord.find('audio').attr('src'));

                  $modalShortcode.modal('open');
                }
              }
            }
          });
        }
      });
    }.bind(this), 1000);

    /**
     * Check browser https and support.
     */

      // Fix up for prefixing
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    navigator.getUserMedia = navigator.getUserMedia
      || navigator.webkitGetUserMedia
      || navigator.mozGetUserMedia
      || navigator.msGetUserMedia;

    if (navigator.getUserMedia === false) {
      this.isDontBrowserSupportHttps = true;
      this.isDontBrowserSupportHttpsMessage = 'Media Record is not supported in your browser, maybe is a good idea update your browser :)';
    }

    let chrome = navigator.userAgent.match(/Chrome/i);
    let safari = navigator.userAgent.match(/Safari/i);
    if (((chrome != null && chrome.length > 0) || (safari != null && safari.length > 0)) && window.location.protocol === 'http:') {
      this.isDontBrowserSupportHttps = true;
      this.isDontBrowserSupportHttpsMessage = 'getUserMedia() no longer works on insecure origins. ' +
        'To use this feature, you should consider switching your wordpress page to a secure origin, ' +
        'such as HTTPS. See https://goo.gl/rStTGz for more details.';
    }
  }
}


// WEBPACK FOOTER //
// ./admin/src/app/components/record/record.component.ts